import { Button } from './ui';

/**
 * Blaetterleiste fuer lange Listen.
 *
 * Bewusst schlicht: zurueck, vorwaerts und die Angabe, welcher Ausschnitt
 * gerade zu sehen ist. Eine Seitenzahlenreihe braucht mehr Platz, als sie am
 * Smartphone wert ist. Bei nur einer Seite blendet sich die Leiste aus.
 */
export function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}): JSX.Element | null {
  const seiten = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;

  const von = (page - 1) * pageSize + 1;
  const bis = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 pt-1">
      <p className="text-sm text-slate-500">
        {von}–{bis} von {total}
      </p>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="secondary"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Zurück
        </Button>
        <span className="text-sm text-slate-600">
          Seite {page} von {seiten}
        </span>
        <Button
          size="sm"
          variant="secondary"
          disabled={page >= seiten}
          onClick={() => onPageChange(page + 1)}
        >
          Weiter
        </Button>
      </div>
    </div>
  );
}
